(function () {
  const input = document.querySelector('[data-pw-predictive-input]');
  const panel = document.querySelector('[data-pw-predictive-panel]');
  if (!input || !panel) return;

  let controller;
  let debouncer;

  function show(html) {
    panel.innerHTML = html;
    panel.hidden = !html.trim();
  }

  async function fetchHTML(q) {
    if (controller) controller.abort();
    controller = new AbortController();

    const params = new URLSearchParams({
      q,
      'resources[type]': 'product,collection,article,page',
      'resources[limit]': '6',
      // VIKTIG: dette peker på DIN eksisterende section
      'section_id': 'predictive-search'
    });

    const res = await fetch(`/search/suggest?${params.toString()}`, {
      signal: controller.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) return show('');

    // Shopify returnerer hele section-HTMLen. Vi kan bruke den som den er,
    // eller hente ut bare #predictive-search-results om ønskelig.
    const html = await res.text();

    // valgfritt: trekk ut bare innmaten
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const inner = tmp.querySelector('#predictive-search-results');
    show(inner ? inner.outerHTML : html);
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(debouncer);

    if (q.length < 2) {
      show('');
      return;
    }

    debouncer = setTimeout(() => fetchHTML(q), 180);
  });

  input.addEventListener('focus', () => {
    if (panel.innerHTML.trim()) panel.hidden = false;
  });

  document.addEventListener('click', (e) => {
    if (!panel.contains(e.target) && e.target !== input) panel.hidden = true;
  });
})();
